import { type RouteSectionProps, useLocation } from '@solidjs/router';
import { type JSX, createEffect, on } from 'solid-js';
import { Drawer } from './Drawer';
import { MobileTopBar } from './MobileTopBar';
import { Sidebar } from './Sidebar';

export const AppLayout = (props: RouteSectionProps): JSX.Element => {
  const location = useLocation();
  let main!: HTMLElement;

  // <main> is the app's only scroller; the router resets window scroll on
  // navigation, not ours, so start each page at the top manually.
  createEffect(
    on(
      () => location.pathname,
      () => {
        main.scrollTop = 0;
        main.scrollLeft = 0;
      },
      { defer: true },
    ),
  );

  return (
    <div class="flex h-dvh overflow-hidden bg-neutral-50 dark:bg-neutral-950">
      {/* Desktop sidebar — hidden below md; the frame never scrolls so it stays
          put; scrolls as a whole when the viewport is shorter than its min height */}
      <div class="hidden h-full shrink-0 overflow-y-auto overscroll-contain md:block">
        <Sidebar variant="desktop" />
      </div>

      {/* Mobile drawer */}
      <Drawer />

      {/* Content area */}
      <div class="flex min-w-0 flex-1 flex-col">
        <div class="md:hidden">
          <MobileTopBar />
        </div>
        {/* overscroll-contain: scrolling past the content edge must not chain
            to the document — macOS would rubber-band the whole page */}
        <main ref={main} class="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain">
          {props.children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
